import React from 'react';
import Header from '../header/Header';
import hero_image from '../../assets/hero_image.png';
import hero_image_back from '../../assets/hero_image_back.png';
import Heart from '../../assets/heart.png';
import Calories from '../../assets/calories.png';
import NumberCounter from 'number-counter';
import './HeroSection.css';

import { motion } from 'framer-motion';

const HeroSection = () => {
    const transition = { type: 'spring', duration: 3 };
    const mobile = window.innerWidth <= 768 ? true : false;

    return (
        <div className="hero" id="home">
            <div className="blur hero-blur"></div>
            <div className="left-h">
                <Header />
                <div className="the-best-ad">
                    <motion.div
                        initial={{ left: mobile ? "165px" : "238px" }}
                        whileInView={{ left: '8px' }}
                        transition={{ ...transition, type: "tween" }}
                    ></motion.div>
                    <span>საუკეთესო ფიტნეს კლუბი ქალაქში</span>
                </div>

                <div className="hero-text">
                    <div>
                        <span className="stroke-text-title">გამოძერწე </span>
                        <span>შენი</span>
                    </div>
                    <div>
                        <span>იდეალური სხეული</span>
                    </div>
                    <div>
                        <span>
                            ჩვენ დაგეხმარებით თქვენი იდეალური სხეულის ფორმირებასა და სრულფასოვანი ცხოვრების შექმნაში.
                        </span>
                    </div>
                </div>
                <div className="figures">
                    <div>
                        <span>
                            <NumberCounter 
                                end={140} 
                                start={69} 
                                delay="3"
                                preFix="+" 
                            />
                        </span>
                        <span>ექსპერტი მწვრთნელი</span>
                    </div>
                    <div>
                        <span>
                            <NumberCounter 
                                end={978} 
                                start={779} 
                                delay="3"
                                preFix="+" 
                            />
                        </span>
                        <span>წევრი</span>
                    </div>
                    <div>
                        <span>
                            <NumberCounter 
                                end={50} 
                                start={10} 
                                delay="3"
                                preFix="+" 
                            />
                        </span>
                        <span>ფიტნეს პროგრამა</span>
                    </div>
                </div>
                <div className="hero-buttons">
                    <button className="btn">დაიწყე</button>
                    <button className="btn">გაიგე მეტი</button>
                </div>
            </div>

            <div className="right-h">
                <button className="btn">შეუერთდი ახლავე</button>
                <motion.div 
                    initial={{ right: "-1rem" }}
                    whileInView={{ right: "4rem" }}
                    transition={transition}
                    className="heart-rate"
                >
                    <img src={Heart} alt="გულის რიტმი" />
                    <span>გულის რიტმი</span>
                    <span>116 ბთ/წთ</span>
                </motion.div>
                <img src={hero_image} alt="ჰერო სურათი" className="hero-image" />
                <motion.img 
                    initial={{ right: '11rem' }}
                    whileInView={{ right: "28rem" }}
                    transition={transition}
                    src={hero_image_back} 
                    alt="ჰერო სურათი უკანა ფონზე"
                    className="hero-image-back" 
                />
                <motion.div 
                    initial={{ right: "37rem" }}
                    whileInView={{ right: "28rem" }}
                    transition={transition}
                    className="calories"
                >
                    <img src={Calories} alt="კალორიები" />
                    <div>
                        <span>დაწვარი კალორიები</span>
                        <span>220 კკალ</span>
                    </div>
                </motion.div>  
            </div>
        </div>
    );
}

export default HeroSection;
